import { BaseService } from "./base.service";
export class CriterionService extends BaseService {
  constructor() {
    super("criteria");
  }
}
